import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { UserInfoModel } from 'src/app/model/user-info.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private isAuthenticated:boolean=false;
  private url;
  private loginEndpoint;
  public userToken:string;
  public userInfo:UserInfoModel;

  constructor(
    private http:HttpClient
  ) {
    this.url=environment.base_url;
    this.loginEndpoint=environment.loginEndpoint;
    this.leerToken();
  }

  login=(user:UserInfoModel)=> {
    return this.http.post(`${this.url}${this.loginEndpoint}`, user).pipe(
      map((resp: any)=> {
        if (resp.codeHttpStatus===200) {
          this.guardarToken(resp.data);
          this.isAuthenticated=true;
          this.userInfo=resp.data;
        }
        return resp;
      })
    );
  }

  logout=()=> {
    localStorage.removeItem('com_token');
    localStorage.removeItem('com_expira');
    localStorage.removeItem('com_userId');
    localStorage.removeItem('com_userTypeId');
    localStorage.removeItem('com_userType');
    localStorage.removeItem('com_role');
    localStorage.removeItem('com_userName');
    localStorage.removeItem('com_officeId');
    localStorage.removeItem('com_employeeId');
    localStorage.removeItem('com_sentAnnex');
    localStorage.removeItem("UserId");
    this.isAuthenticated=false;
    this.userToken='';
    this.userInfo=null;
  }

  // HELPERS
  guardarToken=(idToken: UserInfoModel)=> {
    this.userToken=idToken.segUserId.toString();
    localStorage.setItem("com_token", idToken.segUserId.toString());
    const hoy=new Date();
    hoy.setSeconds(36000);

    // TODO
    localStorage.setItem('com_expira', hoy.getTime().toString());
    localStorage.setItem('com_userId', idToken.userId);
    localStorage.setItem('com_userTypeId', idToken.userTypeId + "");
    localStorage.setItem('com_userType', idToken.userType);
    localStorage.setItem('com_role', idToken.role);
    localStorage.setItem('com_userName', idToken.userName);
    localStorage.setItem('com_officeId', idToken.officeId);
    localStorage.setItem('com_employeeId', idToken.employeeId);
    localStorage.removeItem('com_sentAnnex');
    localStorage.setItem("UserId",this.userToken);
  }

  Authenticated=()=> this.isAuthenticated;

  leerToken=()=> {
    if(localStorage.getItem('com_token')) this.userToken=localStorage.getItem('com_token');
    else this.userToken='';
    return this.userToken;
  }

  estaAutenticado(): boolean {
    if(this.userToken.length<1) return false;

    const expira=Number(localStorage.getItem('com_expira'));
    const expiraDate=new Date();
    expiraDate.setTime(expira);

    if(expiraDate>new Date()) return true;
    else return false;
  }

  getUserRoles(): string[] {
    return this.userInfo && this.userInfo.role ? [this.userInfo.role] : [localStorage.getItem('com_role') || ''];
  }

}
